import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useRouter } from 'next/router';
import Button from '../Button';
import SearchBar from '../search/Searchbar';
import Image from 'next/image';
import { assetPath } from '@/lib/helpers/common';
const Carousel = () => {
  const t = useTranslations('Home');
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const handleClickOrderNow = () => {
    setIsLoading(true);
    router.push('/categories');
  };
  return <div className="carousel_wrapper" data-sentry-component="Carousel" data-sentry-source-file="Carousel.jsx">
            <div className="container">
                <div className="hero_title">
                    <h1>
                        <small> {t('the_chef_label')}</small>
                        {t('the_chef_label_description')}
                    </h1>
                    <span>{t('chef_pick_desc2')}</span>
                    <Button onClick={handleClickOrderNow} isLoading={isLoading} data-sentry-element="Button" data-sentry-source-file="Carousel.jsx">
                        {t('order_now_button')}{' '}
                    </Button>
                </div>
                <div className="carouselImage">
                    <Image src={assetPath('images/carouselImage.webp')} height={500} width={500} alt="carouselImage" className="carouselImg" quality={75} priority={true} data-sentry-element="Image" data-sentry-source-file="Carousel.jsx" />
                </div>
            </div>
            <div className="searchBar_container">
                <div className="container">
                    <SearchBar data-sentry-element="SearchBar" data-sentry-source-file="Carousel.jsx" />
                </div>
            </div>
        </div>;
};
export default Carousel;